import { createStart } from "@tanstack/solid-start"

export const startInstance = createStart(() => {
  return {
    defaultSsr: true
  }
})

startInstance.createMiddleware().server(({ next }) => {
  console.log("Middleware executed")
  return next({
    context: {
      fromStartInstanceMw: true
    }
  })
})
